import { z } from 'zod';

export const rackSchema = z.object({
  text: z.string().min(1),
  location: z.string(),
});

export type RackSchema = z.infer<typeof rackSchema>;
